export const FILTER_ALL = 'ALL';
export const FILTER_NONE = 'NONE';
export const FILTER_CUSTOM = 'CUSTOM';
